/** `primary`: dark green accents (icons). `secondary`: brand green (#70AD47) for bar fills and links. */
export const CHART_COLORS = {
    primary: 'var(--mantine-color-green-9)',
    secondary: 'var(--mantine-color-green-7)',
    quaternary: '#EE964B',
    quinary: '#AFA249',
    muted: '#AAAABD',
}

export const CARTESIAN_GRID_PROPS = {
    strokeDasharray: '3 3',
    stroke: '#E4E2ED',
    strokeOpacity: 0.8,
}
